import {urls} from './constants';
import FormDialog from './signup'
//console.log("login_url:", urls);

export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='.'>
            THE CARDIAC ATLAS PROJECT: CONGENITAL HEART DISEASE
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>

            {/* commenting out to remove about & overview buttons, can delete */}
            {/* <li>
              <a href='#about' className='page-scroll'>
                About
              </a>
            </li> 
             <li>
              <a href='#overview' className='page-scroll'>
                Overview
              </a>
            </li>  */}

            <li>
              <a href={urls.login_url} className='page-scroll'>
                Log in
              </a>
            </li>
            <li>
              {/* <a href='#contact' className='page-scroll'>
                Sign up
              </a> */}
              <FormDialog />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
